import { GetConsentsResponse, PostConsentsRequest } from '../../types/consent';
import { callFes } from '../api';

export const getConsents = async (): Promise<GetConsentsResponse> => {
  return callFes.get(`consents`);
};

export const postConsents = async (payload: PostConsentsRequest): Promise<any> => {
  return callFes.post(`consents`, payload);
};
